import React from 'react';
import {Language} from "../../i18n/language";
import * as style from "../contactDetails/contactDetails.module.scss";
import {NeatForm} from "../../enquiry/neatForm";
import {whatsappApi} from "../../api/whatsappApi";
import {userSession} from "../../userSession/userSession";

export function ContactDetailsKids({name, email, phone, studentName, studentAge, onContactDetailsGiven, validatePhoneUsingWhatsApp}) {

  const fieldNames = ['studentName', 'studentAge', 'name', 'email', 'phone', 'voucher'];
  const fieldTypes = {studentName: "text", studentAge: "number", name: "text", email: "email", phone: "tel", voucher: "text"};
  const requiredFields = [true, true, true, false, true, false];

  const strings = Language.active.cerahKids.emergencyContact.form;
  const labels = {...strings.label}; //Make a copy so as to not manipulate the original object in language.js 
  if (validatePhoneUsingWhatsApp) {
    labels.phone = labels.whatsapp;
  }
  if (userSession.getCountry() === "KR") {
    labels.phone = "KakaoTalk / 📞"
  }
  return (
    <div className={style.onlineEnquiryForm}>
      <div className={style.formBackground}>
        <div className={style.formCorset}>
          <NeatForm
            onSubmit={submit}
            fieldNames={fieldNames}
            required={requiredFields}
            types={fieldTypes}
            placeholders={strings.placeholder}
            labels={labels}
            validate={validate}
            initialValues={{name, email, phone, studentName, studentAge}}
          />
        </div>
      </div>
    </div>
  );

  async function submit({studentName, email, phone, name, studentAge, voucher}) {
    await onContactDetailsGiven({studentName, email, phone, name, studentAge, voucher});
  }

  async function validate(values) {
    const errors = {};
    if (!values.phone.startsWith("+") && !values.phone.startsWith("62")) {
      errors.phone = strings.invalidPhoneFormat;
    } else if (validatePhoneUsingWhatsApp) {
      const onWa = await whatsappApi.validateNumber(values.phone);
      if (!onWa) {
        errors.phone = strings.numberNotOnWhatsapp;
      }
    }
    const regex = /\S+@\S+\.\S+/;
    if (!regex.test(values.email)) {
      errors.email = strings.invalidEmailFormat;
    }
    return errors;
  }
}
